import './AccountOverlay.scss';

import React, { useContext } from 'react';
import { userPolling } from '../services/UserPollingService';
import { environment, getUrlsForEnvironment } from '../../environment';
import { MetricService } from '../services/MetricService';
import { UserContext } from './App';

export const AccountOverlay = () => {
  const userContext = useContext(UserContext);

  const isInExpiredTrial = userContext.daysLeftInTrial === -1 && userContext.inTrial;
  if (!isInExpiredTrial && userContext.subscriptionStatus !== 'CLOSED') {
    return null;
  }

  const handleClick = () => {
    MetricService.increment(
      isInExpiredTrial && userContext.subscriptionStatus !== 'CLOSED'
        ? 'click.task_pane.trial_expired.buy.button'
        : 'click.task_pane.closed_account.buy.button',
    );
    userPolling.setPollingMode('minute');
    if (userContext.daysLeftInTrial === -1 && userContext.buyNowUrl) {
      window.open(userContext.buyNowUrl);
    } else {
      const urls = getUrlsForEnvironment(environment);
      window.open(`${urls.appUrl}/app/?module=users&page=subscription`);
    }

    setTimeout(() => {
      if (userContext.inTrial) {
        userPolling.setPollingMode('rapid');
      } else {
        userPolling.setPollingMode('long');
      }
    }, 1000 * 60 * 15);
  };

  return (
    <div className="account-overlay">
      <div className="overlay-content">
        {userContext.subscriptionStatus === 'CLOSED' && <h3>Your account is closed.</h3>}
        {userContext.daysLeftInTrial === -1 && userContext.subscriptionStatus !== 'CLOSED' && (
          <h3>Your trial has expired.</h3>
        )}
        <button className="buy-now" onClick={handleClick} type="button">
          Buy Now
        </button>
      </div>
    </div>
  );
};
